import * as React from 'react';
import isEqual from 'react-fast-compare';
import OverlayTrigger from '@/components/Overlay/OverlayTrigger';
import { Popover } from 'react-bootstrap';
import styles from './IconPopover.module.scss';

type Props = {
    extraIcon?: boolean;
    extraIconClassName?: string;
    headline?: React.ReactNode;
    icon: React.ReactNode;
    iconClassName?: string;
    id: string;
    text: React.ReactNode;
};

const IconPopover = (props: Props) => {
    const { extraIcon = false, extraIconClassName = '', headline, icon, iconClassName = '', id, text } = props;

    return (
        <OverlayTrigger
            overlay={
                // @ts-ignore replace bootstrap
                <Popover className={styles.popoverStyle} id={id} in={styles}>
                    <div className={styles.descriptionContainer}>
                        <div className={styles.headline}>
                            {Boolean(extraIcon) && (
                                <span className={extraIconClassName}>{extraIcon === true ? icon : extraIcon}</span>
                            )}
                            {headline}
                        </div>
                        <span className={styles.text}>{text}</span>
                    </div>
                </Popover>
            }
            placement="bottom"
            trigger={['hover', 'focus']}
        >
            <div className={iconClassName}>{icon}</div>
        </OverlayTrigger>
    );
};

export default React.memo<Props>(IconPopover, isEqual);
